export default "__VITE_ASSET__CgxUYeVF__"